import { render, staticRenderFns } from "./tableForm56_1.vue?vue&type=template&id=0b35f7ba&scoped=true"
import script from "./tableForm56_1.vue?vue&type=script&lang=js"
export * from "./tableForm56_1.vue?vue&type=script&lang=js"
import style0 from "./tableForm56_1.vue?vue&type=style&index=0&id=0b35f7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35f7ba",
  null
  
)

export default component.exports